<div class="sa-signup">
  <div class="sa-signup-container flex flex-center md-block h-100">
    <!--    - product detials
                - dynamic theme     -->
    <div class="sa-signup-details flex-center">
      <div class="sa-signup-details-container">
        <sa-icon class="md-hidden" img="{{product_logo}}" imgWidth="110" imgHeight="38" [href]="sarasLink" [hrefTarget]="'blank'" ></sa-icon>
        <span class="sa-logo hidden md-flex">
          <sa-icon img="{{product_logo}}" imgWidth="110" imgHeight="38" [href]="sarasLink" [hrefTarget]="'blank'" ></sa-icon>
        </span>
        @if(webflowContentReady && LoginSignupPage){ @if(LoginSignupPage.title){
        <div class="title" [class.hide-on-message-view]="messageView">{{ LoginSignupPage.title }}</div>
        } @if(LoginSignupPage.cards){
        <div class="sa-signup-details-cards flex-center flex-col md-hidden">
          <ng-container *ngFor="let card of LoginSignupPage.cards">
            <sa-card
              [title]="card.fieldData['card-title']"
              [body]="card.fieldData['card-description']"
              [icon]="card.fieldData['card-logo']?.[0]?.url || ''"
              iconSize="50"
              [showCardBody]="true"
            ></sa-card>
          </ng-container>
        </div>
        } @if(LoginSignupPage.companies){ @if(LoginSignupPage.subtitle){
        <div class="text text-14 sa-signup-details-footer flex md-hidden">
          <span>{{ LoginSignupPage.subtitle }}</span
          ><span class="sa-signup-details-footer-extra"></span>
        </div>
        }
        <div class="sa-signup-details-companies flex" [class.hide-on-message-view]="messageView">
          <ng-container *ngFor="let company of LoginSignupPage.companies">
            <sa-icon [iconUrl]="company.fieldData['client-logo']?.url || ''" size="60"></sa-icon>
          </ng-container>
        </div>
        } }
      </div>
    </div>

    <!--    - signup form       -->
    <div class="sa-signup-form flex-center">
      @if(!messageView){
      <div class="sa-form-container">
        @if(isLoading){
        <div class="sa-form-overlay"></div>
        } @if(toast){
        <sa-toast
          class="block"
          [subHeading]="toast.subHeading || ''"
          [status]="toast.status || 'success'"
          width="100%"
        ></sa-toast>
        }

        <!--    - chip(small)       -->

        <div class="sa-form-header">
          <sa-chip
            text="START FOR FREE"
            state="small"
            filling="primary filled"
          ></sa-chip>
          <div class="title" [style.visibility]="productTitle ? '' : 'hidden'">Create your {{productTitle}} account</div>
          <div class="sub-title">
            Turn your data into decisions with Saras Data Suite
          </div>
        </div>

        <div class="sa-form-wrapper flex flex-col">
          @if(isFormFieldsReady){
          <form [formGroup]="form" class="flex flex-col" (ngSubmit)="onSubmit()">
            <formly-form
              [form]="form"
              [model]="model"
              [fields]="fields"
              (modelChange)="modelChangeHandler($event)"
            >
            </formly-form>

            <!-- [disabled]="!form.valid" -->
            <sa-button
              [isSubmit]="true"
              text="Create Account"
              type="primary"
              size="medium"
              state="default"
              width="100%"
              [showSpinner]="isLoading"
            ></sa-button>
          </form>
          }
        </div>
        <div class="text text-12">
          By signing up, I agree to the Saras
          <a
            [href]="privacyPolicy"
            target="_blank"
            class="link"
            >Privacy Policy</a
          >
          and
          <a
            [href]="termsOfUse"
            target="_blank"
            class="link"
            >Terms of Service</a
          >
        </div>
        @if(loginLink){
          <div class="text text-14">
            Already have an account? <a [href]="loginLink" class="link">Login</a>
          </div>
        }
      </div>
      }@else{
      <sa-message-view
        [props]="messageView"
        (onClick)="onMessageViewEvent($event)"
      ></sa-message-view>
      }
    </div>
  </div>
</div>
